


























































































































import { Vue, Component, Watch } from "vue-property-decorator";
import * as api from "@/service/rules";
import { isNotNull, isNull } from "@/utils/fun";

@Component({
  components: {},
})
export default class Rules extends Vue {
  searchValue: any = "";
  categoryList = [];
  articleList = [];
  subValue: any = {};
  brumbValue = {};
  itemValue: any = {};
  articleId: number | string = "";
  showList = true;
  showSearchResult = false;
  article = {};
  searchResult = [];
  loading = false;

  @Watch("$route.name")
  watchRoute() {
    this.getCategory();
  }

  @Watch("itemValue", { immediate: true })
  async updateItem(itemValue: any) {
    if (itemValue?.id) {
      await this.getArticleList();
      this.getBrumb(itemValue.id);
    }
  }
  async created() {
    const { article, category, search } = this.$route.query;
    await this.getCategory();
    if (isNotNull(article)) {
      this.clickArticle(article, "route");
      return;
    }
    if (isNotNull(category)) {
      this.itemValue = { id: Number(category) };
      return;
    }
    if (isNotNull(search)) {
      this.searchValue = search;
      this.clickSearch();
      return;
    }
  }

  getBrumb(id: number) {
    for (let index = 0; index < this.categoryList.length; index++) {
      const element: any = this.categoryList[index];
      if (element?.child.length > 0) {
        for (let i = 0; i < element?.child.length; i++) {
          const el = element?.child[i];
          if (el.id === id) {
            this.brumbValue = {
              one: element.name,
              two: el.name,
            };
            this.subValue = { id: element.id };
          }
        }
      }
    }
  }
  async getCategory() {
    const { category, article, cate1, cate2 } = this.$route.query;
    const type = this.$route.name === "rules" ? 2 : 1; //帮助中心分类id为1，规则中心分类id为2
    const categoryList = await api.queryCategory(type);
    this.categoryList = categoryList.filter(
      (item: any) => item.child?.length > 0
    );
    if (isNull(category) && isNull(article)) {
      const cate1Value: any = this.categoryList.find((item: any) => String(item.id) === cate1)
     const cate2Value = cate1Value?.child?.find((item: any) => String(item.id) === cate2)
      this.subValue = cate1Value || this.categoryList[0];
      this.itemValue = cate2Value || this.subValue?.child[0] || {};
    }
  }

  async getArticleList(id?: number | string) {
    const param = {
      cat_id: id || this.itemValue.id,
      rank: 3,
      page: 1,
      page_size: 50,
      source: this.$route.name === "admin" ? "xm" : "",
    };
    this.articleList = await api.queryArticleList(param);
  }

  async getArticleContent(boo?: any) {
    const params: any = {
      article_id: this.articleId,
      source: this.$route.name === "admin" ? "xm" : "",
    };
    console.log(
      "🚀 ~ file: Rules.vue ~ line 193 ~ Rules ~ getArticleContent ~ this.$route.query.preview",
      this.$route.query.preview
    );
    if (isNotNull(this.$route.query.preview)) {
      params.preview = 1;
    }
    const article = await api.queryArticleDetail(params);
    this.article = article;
    if (boo === "route") {
      this.itemValue = { id: article.cate_id3 };
    }
  }

  async getSearchResult() {
    const params = {
      key_word: this.searchValue,
      page: 1,
      page_size: 50,
      source: this.$route.name === "admin" ? "xm" : "",
    };
    this.loading = true
    try{
      this.searchResult = await api.searchArticle(params)
      this.loading = false
    }catch(e){
      this.loading = false
    }
  }

  clickSub(sub: any) {
    if (sub.id === this.subValue.id) {
      this.subValue = {};
    } else {
      this.subValue = sub;
    }
  }

  clickItem(item: any) {
    this.itemValue = item;
    this.showList = true;
  }

  clickArticle(id: any, boo?: string) {
    this.showList = false;
    this.showSearchResult = false;
    this.articleId = id;
    this.$router.push({
      query: { ...this.$route.query, article: id },
    });
    this.getArticleContent(boo);
  }

  clickSearch() {
    this.showSearchResult = true;
    this.getSearchResult();
  }
}
